import React, { useEffect, useState } from "react";
import { FaEdit } from "react-icons/fa";
//import useEscClose from "../../useEscClose";
import apiRoutes from "../../../api/apiRoutes";
import { appFetchJson } from "../../../utils/http";
import ListHeader from "../../../components/listing/ListHeader";
import ListFooter from "../../../components/listing/ListFooter";
import CrearPrecioProductoEess from "./CrearPrecioProductoEess";
import EditarPrecioProductoEess from "./EditarPrecioProductoEess";
import FiltroPrecioProductoEess from "./FiltroPrecioProductoEess";
import DynamicTable from "../../../components/listing/DynamicTable"; // <--- IMPORTANTE

const DEFAULT_PAGE_SIZE = 30;

export default function ListarPrecioProductoEess() {
  // ============================
  //         LISTADO
  // ============================
  const [items, setItems] = useState([]);
  const [paginaActual, setPaginaActual] = useState(1);
  const [porPagina, setPorPagina] = useState(DEFAULT_PAGE_SIZE);
  const [totalBackend, setTotalBackend] = useState(0);
  const [cargando, setCargando] = useState(false);
  const [mostrarCrear, setMostrarCrear] = useState(false);
  const [mostrarEditar, setMostrarEditar] = useState(false);
  const [registroEditar, setRegistroEditar] = useState(null);

  // ============================
  //         FILTROS
  // ============================
  const [filtros, setFiltros] = useState({});
  const [mostrarFiltros, setMostrarFiltros] = useState(false);

  const limpiarSeleccion = () => {
    setFiltros({});
    setPaginaActual(1);
  };

  const handleAplicarFiltros = (nuevosFiltros) => {
    setFiltros(nuevosFiltros);
    setPaginaActual(1);
    setMostrarFiltros(false);
  };

  // ============================
  //         FETCH
  // ============================
  const fetchPrecios = async (
    pageIndex = paginaActual - 1,
    size = porPagina,
    filtrosAplicados = filtros,
  ) => {
    setCargando(true);
    try {
      const { eessNombre, productoNombre, ...filtrosLimpios } = filtrosAplicados;

      const url = apiRoutes.precioProductoEess.listUrl({
        page: pageIndex,
        size,
        ...filtrosLimpios,
      });

      const data = await appFetchJson(url);
      setItems(data?.items || []);
      setTotalBackend(data?.totalElements ?? 0);
    } catch (err) {
      console.error("Error al cargar precios EESS:", err);
      setItems([]);
      setTotalBackend(0);
    } finally {
      setCargando(false);
    }
  };

  useEffect(() => {
    fetchPrecios(paginaActual - 1, porPagina, filtros);
  }, [paginaActual, porPagina, filtros]);

  const cambiarPagina = (num) => {
    setPaginaActual(num);
  };

  const handleEditar = (row) => {
    setRegistroEditar(row);
    setMostrarEditar(true);
  };

  // ====================================================================
  // DEFINICIÓN DE COLUMNAS (TOTAL 100%)
  // ====================================================================
  const columns = [
    // 1. PRODUCTO (18%)
    { 
      header: "Producto", 
      type: "text", 
      width: "18%", 
      cellClass: "whitespace-normal break-words leading-tight font-medium text-gray-800",
      render: (row) => row.productoNombre || row.productoId || "-"
    },
    
    // 2. PRECIO VENTA (9%)
    { 
      header: "Valor Precio", 
      type: "center", 
      width: "9%", 
      render: (row) => row.precio ? Number(row.precio).toLocaleString("es-PY") : "0"
    },
    
    // 3. PRECIO COMPRA (9%)
    { 
      header: "Precio Compra", 
      type: "center", 
      width: "9%", 
      render: (row) => row.precio2 ? Number(row.precio2).toFixed(2) : "0.00" 
    },
    
    // 4. FECHA (9%)
    { 
      header: "Fecha", 
      accessor: "fecha", 
      type: "center", 
      width: "9%" 
    },
    
    // 5. EE.SS. (18%)
    { 
      header: "EE.SS.", 
      type: "text", 
      width: "18%",
      cellClass: "text-gray-600 whitespace-normal break-words leading-tight",
      render: (row) => row.eessNombre || row.eessId || "-"
    },

    // 6. DIRECCIÓN (18%) - NUEVA COLUMNA
    { 
      header: "Dirección", 
      type: "text", 
      width: "18%",
      cellClass: "text-gray-600 whitespace-normal break-words leading-tight",
      render: (row) => row.eessDireccion || "-"
    },
    
    // 7. ESTADO (10%)
    { 
      header: "Estado", 
      type: "status", 
      width: "10%",
      render: (it) => {
        const desc = (it.estadoDescripcion || it.estado || "").toUpperCase();
        const esActivo = desc.includes('ACTIVO') && !desc.includes('INACTIVO');
        const textColor = esActivo ? 'text-green-600' : 'text-red-600';
        return <span className={`font-bold ${textColor}`}>{it.estadoDescripcion || it.estado}</span>;
      }
    },
    
    // 8. ACCIÓN (9%)
    {
      header: "Acción",
      type: "action", 
      width: "9%",
      render: (it) => (
        <div className="flex justify-center items-center gap-1">
          <button className="text-gray-500 hover:text-blue-600 p-1" onClick={() => handleEditar(it)} title="Editar">
            <FaEdit />
          </button>
        </div>
      )
    }
  ];

  // Función para el borde de color en móvil (ResponsiveTableContainer lo usa)
  const getRowBorderColor = (row) => {
    const desc = (row.estadoDescripcion || row.estado || "").toUpperCase();
    const esActivo = desc.includes('ACTIVO') && !desc.includes('INACTIVO');
    return esActivo ? 'border-green-600' : 'border-red-600';
  };

  // ============================
  //         RENDER
  // ============================
  return (
    <div className="page">

      <ListHeader
        title="Precio Producto por EE.SS."
        onFilterClick={() => setMostrarFiltros(true)} 
        showAdd={true} 
        onAddClick={() => setMostrarCrear(true)}
        filters={filtros}
        onClearFilters={limpiarSeleccion}
        pageSize={porPagina}
        onPageSizeChange={(size) => {
          setPorPagina(size);
          setPaginaActual(1);
        }}
      />

      {/* REEMPLAZO DE LA TABLA MANUAL POR DYNAMICTABLE */}
      {cargando && <div className="mt-2 text-sm text-center text-gray-500">Cargando datos...</div>}
      
      {!cargando && (
        <DynamicTable 
          size="M" // 'M' cambia a tarjetas en < 1024px.
          data={items}
          columns={columns}
          getRowColor={getRowBorderColor}
        />
      )}

      <ListFooter
        page={paginaActual}
        pageSize={porPagina}
        total={totalBackend}
        onPageChange={cambiarPagina}
      />

      {/* MODALES */}
      {mostrarCrear && (
        <CrearPrecioProductoEess
          onClose={() => setMostrarCrear(false)}
          onCreated={() => {
            setPaginaActual(1);
            fetchPrecios(0, porPagina, filtros);
          }}
        />
      )}

      {mostrarEditar && registroEditar && (
        <EditarPrecioProductoEess
          record={registroEditar}
          onClose={() => {
            setMostrarEditar(false);
            setRegistroEditar(null);
          }}
          onUpdated={() => {
            fetchPrecios(paginaActual - 1, porPagina, filtros);
          }}
        />
      )}

      {mostrarFiltros && (
        <FiltroPrecioProductoEess
          initialFilters={filtros}
          onSubmit={handleAplicarFiltros}
          onClose={() => setMostrarFiltros(false)}
        />
      )}
    </div>
  );
}